import { render, staticRenderFns } from "./ReportResultTableServerSide.vue?vue&type=template&id=14a24e83"
import script from "./ReportResultTableServerSide.vue?vue&type=script&lang=js"
export * from "./ReportResultTableServerSide.vue?vue&type=script&lang=js"
import style0 from "./ReportResultTableServerSide.vue?vue&type=style&index=0&id=14a24e83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports